//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('customerInvoicing', {
//        templateUrl: 'views/components/views/customerInvoicing/customerInvoicing.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'customerInvoicingService', 'ttGridFactory', function ($stateParams, stateService, utilityService, translateService, modalService, customerInvoicingService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                gridReady: false,
//                setting: {},
//                creatingInvoice: false,
//                settingNotInvoice: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await customerInvoicingService.getCustomerInvoicing({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: vm.model.setting
//                    };

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.createChanges = function () {
//                vm.model.creatingInvoice = true;

//                let allData = vm.grid.gridfunc.getAllRows().map(function (a) { return { "powtime_keyno": a.powtime_keyno, "is_selected": a.is_selected }; });
//                let mergeObj = vm.model.setting;
//                mergeObj.records = allData;

//                customerInvoicingService.createInvoice(mergeObj).then((response) => {
//                    if (response[0].errorcode === '-1') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.creatingInvoice = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.creatingInvoice = false;
//                        stateService.back();
//                    }
//                });
//            }

//		    // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON SET NOT PROCEDURE FUNCTION CALL

//            vm.setNotChanges = function () {
//                vm.model.settingNotInvoice = true;

//                let allData = vm.grid.gridfunc.getAllRows().map(function (a) { return { "powtime_keyno": a.powtime_keyno, "is_selected": a.is_selected }; });
//                let mergeObj = vm.model.setting;
//                mergeObj.records = allData;

//                customerInvoicingService.setNotInvoice(mergeObj).then((response) => {
//                    if (response[0].errorcode === '-1') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.settingNotInvoice = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.settingNotInvoice = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SET NOT PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
